/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Questions_Heading_OneInputs */

const en_platform_questions_heading_one = /** @type {(inputs: Platform_Questions_Heading_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you move`)
};

const pl_platform_questions_heading_one = /** @type {(inputs: Platform_Questions_Heading_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zanim przeniesiesz`)
};

/**
* | output |
* | --- |
* | "Before you move" |
*
* @param {Platform_Questions_Heading_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_questions_heading_one = /** @type {((inputs?: Platform_Questions_Heading_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Questions_Heading_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_questions_heading_one(inputs)
	return en_platform_questions_heading_one(inputs)
});